import { useState } from 'react'
import { TriangleAlert, X } from 'lucide-react'
import { useOmpNav } from '../hooks/useOmpNav'
import { usePaymentUpdateAction } from '../hooks/usePaymentUpdateAction'

// "Click here" opens the payment-update popup; without the rebill intent it falls
// back to the payment page.
const OmpPaymentIssueBanner = () => {
  const { navigateWithInput } = useOmpNav()
  const { available, start } = usePaymentUpdateAction()
  const [dismissed, setDismissed] = useState(false)

  if (dismissed) {
    return null
  }

  return (
    <div className="omp-payment-issue-banner" role="alert">
      <div className="omp-payment-issue-banner-body">
        <TriangleAlert size={20} className="omp-payment-issue-banner-icon" />
        <p>
          Your subscription is paused due to a payment issue.{' '}
          <button
            type="button"
            className="omp-payment-issue-banner-link"
            onClick={() => (available ? start() : navigateWithInput('/portal/account/payment'))}>
            Click here
          </button>{' '}
          to update your payment.
        </p>
      </div>
      <button
        type="button"
        className="omp-payment-issue-banner-close no-transform"
        aria-label="Dismiss"
        onClick={() => setDismissed(true)}>
        <X size={16} />
      </button>
    </div>
  )
}

export default OmpPaymentIssueBanner
